import { type ParameterID, type CoreItemCategory } from '@flecto/types'

import { CardProductCategory } from '../CardProductCategory/CardProductCategory'
import { Carousel, type CarouselProps } from '../Carousel/Carousel'

export type CarouselProductCategoriesProps = CarouselProps & {
  categories?: CoreItemCategory[]
  excludeCategories?: ParameterID[]
}

export function CarouselProductCategories({
  categories,
  excludeCategories = [],
  ...props
}: CarouselProductCategoriesProps) {
  const categoriesCarousel = categories?.filter(
    (c) => !excludeCategories?.includes(c.id)
  )

  if ((categoriesCarousel?.length ?? 0) <= 0) {
    return
  }

  return (
    <Carousel {...props}>
      {categoriesCarousel?.map((cat) => (
        <Carousel.Slide key={cat.id}>
          <CardProductCategory category={cat} />
        </Carousel.Slide>
      ))}
    </Carousel>
  )
}
